// 운영(배포된 빌더)에서는 디버그 로그(log/info/debug)를 끈다. error/warn 은 유지.
//
// UI 빌드 산출물(bundle.js)을 git 에 커밋해 배포하므로, 빌드타임 minify(terser)는
// git diff 폭발 때문에 피한다. 대신 런타임으로 분기한다: localhost 가 아니면 off.
// (로컬 테스트는 localhost 에서 하므로 로그가 그대로 남는다.)
var hostname = window.location.hostname;
var isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

if (!isLocalhost) {
    var noop = function () {};
    console.log = noop;
    console.info = noop;
    console.debug = noop;
}
